import { useQuery } from "@tanstack/react-query";
import postsAPI from "../../api/posts/api";

export function getQueryKey(id: string | number) {
  return ["posts", id];
}

export function useGetPostById(
  id: string | number,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: getQueryKey(id),
    queryFn: () => postsAPI.getPostById(id),
    enabled: !!id && options?.enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
